<template>
  <div>
    <!-- 加载页 -->
    <div v-if="showLoading" class="loading-page">
      <!-- <img class="loading-logo" src="../assets/logo.png" alt="logo" /> -->
      <!-- <img class="loading-logo" src="../assets/lodingText.png" alt="logo" /> -->
       <img class="loading-logo" src="../assets/887a6e99b6468ceb22eb0695015a18e3.png" alt="logo">
      <div class="loading-progress-container">
        <div class="loading-progress-text">{{ loadingPercent }}%</div>
        <div class="loading-progress-bar">
          <div class="loading-progress-inner" :style="{ width: loadingPercent + '%' }"></div>
        </div>
        <!-- <div class="loading-slogan">
          <div class="slogan-cn">池内防水，原来可以如此简单</div>
          <div class="slogan-en">Waterproofing，So Easy</div>
        </div> -->
      </div>
    </div>
    <!-- 主页面内容 -->
    <div v-else class="pc-home">
      <!-- 左上角 Logo -->
      <div class="pc-logo">
        <img src="../assets/17dba2e30afc8590182254fe68bcc7b0.png" alt="logo" />
      </div>
      <div class="pool-view">
        <template v-if="selectedPattern">
          <a-spin :spinning="imageLoading" tip="图片加载中...">
            <div class="image-container">
              <img 
                v-if="currentView"
                :src="currentView" 
                :alt="viewMode"
                @load="handleImageLoad"
                @error="handleImageError"
                class="pool-image"
              />
            </div>
          </a-spin>
        </template>
        <template v-else>
          <div class="choose-pattern-tip">
            <a-icon type="info-circle" style="font-size: 32px; color: #1890ff;" />
            <div class="tip-text">{{ $t('message.tip.choosePattern') }}</div>
          </div>
        </template>
      </div>

      <!-- 统一控制面板 -->
      <div class="control-panel">
        <div class="control-group">
          <div class="control-btn" @click="toggleLanguage">
            <a-icon type="global" />
            <span>{{ $i18n.locale === 'zh' ? 'English' : '中文' }}</span>
          </div>
          <div
            class="control-btn"
            @click="toggleMusic"
            :class="{ 'active': isMusicPlaying }"
          >
            <a-icon :type="isMusicPlaying ? 'sound' : 'sound'" :class="{ 'music-playing': isMusicPlaying }" />
            <span>{{ isMusicPlaying ? $t('message.button.pause') : $t('message.button.play') }}</span>
          </div>
          <div class="control-btn" @click="handleShare">
            <a-icon type="share-alt" />
            <span>{{ $t('message.button.share') }}</span>
          </div>
        </div>

        <div class="view-mode-group">
          <div 
            class="view-mode-btn" 
            :class="{ active: viewMode === 'full' }"
            @click="viewMode = 'full'"
          >
            <div class="btn-icon">
              <a-icon type="picture" />
              <span class="btn-text">{{ $t('message.viewMode.full') }}</span>
            </div>
          </div>
          <div 
            class="view-mode-btn" 
            :class="{ active: viewMode === 'empty' }"
            @click="viewMode = 'empty'"
          >
            <div class="btn-icon">
              <img 
                :src="viewMode === 'empty' ? require('../assets/water-off.svg') : require('../assets/water-on.svg')" 
                alt=""
              />
              <span class="btn-text">{{ $t('message.viewMode.empty') }}</span>
            </div>
          </div>
          <div 
            class="view-mode-btn" 
            :class="{ active: viewMode === 'detail' }"
            @click="viewMode = 'detail'"
          >
            <div class="btn-icon">
              <a-icon type="zoom-in" />
              <span class="btn-text">{{ $t('message.viewMode.detail') }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 花色选择面板 -->
      <div class="pattern-panel" :class="{ 'pattern-panel-show': showPatternPanel }">
        <div class="panel-logo">
          <!-- <img src="../assets/logo.png" alt="logo" /> -->
          <img src="../assets/17dba2e30afc8590182254fe68bcc7b0.png" alt="logo" />
        </div>
        <a-button
          v-if="showPatternPanel"
          class="panel-toggle-btn"
          @click="showPatternPanel = false"
          shape="circle"
          :style="{ left: '300px', top: '70px' }"
        >
          <a-icon type="left" />
        </a-button>
        <a-button
          v-else
          class="panel-toggle-btn"
          @click="showPatternPanel = true"
          shape="circle"
          :style="{ right: '-40px', top: '70px' }"
        >
          <a-icon type="right" />
        </a-button>
        <div class="panel-content-area">
          <!-- View 1: Category Selection -->
          <div v-if="panelView === 'categories'" class="category-view">
            <h3>{{ $t('message.category') }}</h3>
            <a-spin :spinning="categoryLoading">
              <div class="category-list">
                <div 
                  v-for="category in categories" 
                  :key="category.id"
                  class="category-item" 
                  @click="selectCategory(category)"
                  :class="{ 'selected-category': selectedCategoryId === category.id && !patternsLoading }" 
                >
                  <img 
                    v-if="category.image" 
                    :src="categoryImageUrl(category)" 
                    :alt="categoryName(category)" 
                    class="category-item-image"
                  />
                  <div v-else class="category-item-no-image">无图</div>
                  <div class="category-item-name">{{ categoryName(category) }}</div>
                </div>
              </div>
            </a-spin>
          </div>

          <!-- View 2: Pattern Selection -->
          <div v-if="panelView === 'patterns'" class="pattern-view">
            <div class="pattern-view-header">
              <a-button @click="navigateToCategoryView" size="small" class="back-button">
                <a-icon type="arrow-left" /> {{ $t('message.backToCategories') || '返回类型' }}
              </a-button>
              <h3 class="pattern-view-title">{{ currentSelectedCategoryNameForTitle }}</h3>
            </div>
            <a-spin :spinning="patternsLoading">
              <div class="manual-pattern-grid" @scroll="handleScroll">
                <div 
                  v-for="item in patterns" 
                  :key="item.id"
                  class="manual-pattern-item"
                  @click="selectPattern(item)"
                  :class="{ 'selected-pattern-item': selectedPattern && selectedPattern.id === item.id }"
                >
                  <img 
                    :src="patternImageUrl(item)" 
                    :alt="patternName(item)" 
                    class="manual-pattern-item-image"
                  />
                  <div class="manual-pattern-item-name">{{ patternName(item) }}</div>
                </div>
                <div v-if="!patternsLoading && patterns.length === 0" class="no-patterns-message">
                  {{ $t('message.noPatterns') || '暂无花色' }}
                </div>
                <div v-if="hasMore" class="load-more-container">
                  <a-button 
                    type="primary" 
                    :loading="isLoadingMore"
                    @click="loadMore"
                    class="load-more-btn"
                  >
                    {{ isLoadingMore ? $t('message.loading') : $t('message.loadMore') }}
                  </a-button>
                </div>
              </div>
            </a-spin>
          </div>
        </div>
      </div>

      <audio ref="bgMusic" loop :src="musicUrl">
        <!-- <source src="http://ychz.yredis.com/music/background.mp3" type="audio/mpeg"> -->
      </audio>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'PC',
  data() {
    return {
      isMusicPlaying: true,
      viewMode: 'full',
      showPatternPanel: true,
      patternsLoading: false,
      imageLoading: false,
      patterns: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      selectedPattern: null,
      musicUrl: '',
      categories: [],
      selectedCategoryId: null,
      categoryLoading: false,
      panelView: 'categories',
      showLoading: true,
      loadingPercent: 0,
      imagesToLoad: [],
      loadedImagesCount: 0,
      isLoadingMore: false,
      hasMore: true
    }
  },
  computed: {
    currentView() {
      if (!this.selectedPattern) return ''
      // 根据场景模式选择对应的图片
      let imageUrl = ''
      if (this.viewMode === 'full') {
        imageUrl = this.selectedPattern.have_image
      } else if (this.viewMode === 'empty') {
        imageUrl = this.selectedPattern.not_image
      } else if (this.viewMode === 'detail') {
        imageUrl = this.selectedPattern.detail_image
      }
      
      // 确保URL是有效的
      if (!imageUrl) {
        console.warn('图片URL为空')
        return ''
      }
      
      // 处理URL中的转义字符
      try {
        // 解码URL中的转义字符
        imageUrl = decodeURIComponent(imageUrl)
        // 替换转义的反斜杠
        imageUrl = imageUrl.replace(/\\/g, '')
        // 确保URL是完整的
        if (!imageUrl.startsWith('https')) {
          imageUrl = 'https://poollineradmin.landy360.com' + imageUrl
        }
        console.log('处理后的图片URL:', imageUrl)
        return imageUrl
      } catch (e) {
        console.error('无效的图片URL:', imageUrl, e)
        return ''
      }
    },
    currentSelectedCategoryNameForTitle() {
      if (!this.selectedCategoryId || this.categories.length === 0) return this.$t('message.patterns') || '花色列表';
      const category = this.categories.find(c => c.id === this.selectedCategoryId);
      return category ? (this.$i18n.locale === 'zh' ? category.name : category.english) : (this.$t('message.patterns') || '花色列表');
    }
  },
  mounted() {
    this.initWithLoading();
  },
  methods: {
    async initWithLoading() {
      this.showLoading = true;
      this.loadingPercent = 0;
      this.imagesToLoad = [];
      this.loadedImagesCount = 0;
      // 解析URL参数
      const searchParams = new URLSearchParams(window.location.search);
      const urlCateId = searchParams.get('cateId');
      const urlPatternId = searchParams.get('patternId');
      try {
        // 1. 获取类型列表
        const cateRes = await request({ url: '/index/cateList', method: 'get' });
        this.loadingPercent = 30;
        if (cateRes && cateRes.data && Array.isArray(cateRes.data)) {
          this.categories = cateRes.data;
          let targetCate = null;
          // 优先用URL参数cateId
          if (urlCateId) {
            targetCate = this.categories.find(c => String(c.id) === String(urlCateId));
          }
          // 没有就用默认
          if (!targetCate) {
            targetCate = this.categories.find(c => c.is_default === 2);
          }
          if (targetCate) {
            this.selectedCategoryId = targetCate.id;
            // 2. 获取该类型下的花色
            const patternRes = await request({
              url: '/index/sceneList',
              method: 'get',
              params: {
                cate_id: targetCate.id,
                page: 1,
                limit: this.pageSize
              }
            });
            this.loadingPercent = 60;
            this.patterns = Array.isArray(patternRes.data && patternRes.data.list) ? patternRes.data.list : [];
            this.total = patternRes.data && patternRes.data.count ? patternRes.data.count : 0;
            let targetPattern = null;
            // 优先用URL参数patternId
            if (urlPatternId) {
              targetPattern = this.patterns.find(p => String(p.id) === String(urlPatternId));
            }
            // 没有就用默认
            if (!targetPattern) {
              targetPattern = this.patterns.find(p => p.is_default === 2);
            }
            if (!targetPattern && this.patterns.length > 0) {
              targetPattern = this.patterns[0];
            }
            this.selectedPattern = targetPattern;
            // 默认显示分类选择页面
            this.panelView = 'categories';
            // 3. 预加载所有图片
            await this.preloadImages();
          }
        }
      } catch (e) {
        console.error('初始化加载失败:', e);
      } finally {
        // 访问日志和音乐等其他初始化
        request({ url: '/index/visitLog', method: 'get' });
        this.fetchMusicUrl();
      }
    },
    async fetchMusicUrl() {
      try {
        const res = await request({
          url: '/index/configData',
          method: 'get',
          params: {
            name: 'music'
          }
        });
        if (res && res.data && res.data.content) {
          this.musicUrl = res.data.content;
          // 获取到URL后再尝试播放音乐
          this.$nextTick(() => {
            this.playMusic();
          });
        } else {
          console.error('获取背景音乐URL失败或数据格式不正确:', res);
        }
      } catch (error) {
        console.error('获取背景音乐URL失败:', error);
      }
    },
    selectCategory(category) {
      this.selectedCategoryId = category.id;
      this.currentPage = 1;
      this.patterns = [];
      this.total = 0;
      this.selectedPattern = null;
      this.fetchPatterns(category.id).then(() => {
        this.panelView = 'patterns';
      }).catch(() => {
        this.panelView = 'patterns';
      });
    },
    async fetchPatterns(categoryId, isLoadMore = false) {
      if (!categoryId) {
        this.patternsLoading = false;
        this.patterns = [];
        this.total = 0;
        return;
      }
      
      if (isLoadMore) {
        if (this.isLoadingMore || !this.hasMore) return;
        this.isLoadingMore = true;
      } else {
        this.patternsLoading = true;
        this.currentPage = 1;
        this.patterns = [];
        this.hasMore = true;
      }

      try {
        const res = await request({
          url: '/index/sceneList',
          method: 'get',
          params: {
            cate_id: categoryId,
            page: this.currentPage,
            limit: this.pageSize
          }
        });
        
        const newPatterns = Array.isArray(res.data && res.data.list) ? res.data.list : [];
        this.total = res.data && res.data.count ? res.data.count : 0;
        
        if (isLoadMore) {
          this.patterns = [...this.patterns, ...newPatterns];
        } else {
          this.patterns = newPatterns;
        }
        
        this.hasMore = this.patterns.length < this.total;
        
        if (this.patterns.length > 0 && !isLoadMore) {
          if (!this.selectedPattern || !this.patterns.find(p => p.id === this.selectedPattern.id)) {
            this.selectPattern(this.patterns[0]);
          }
        }
      } catch (error) {
        console.error('获取花色列表失败：', error);
        this.$message.error(this.$t('message.fetchPatternsError') || '获取花色列表失败');
        if (!isLoadMore) {
          this.patterns = [];
          this.total = 0;
          this.selectedPattern = null;
        }
      } finally {
        this.patternsLoading = false;
        this.isLoadingMore = false;
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchPatterns(this.selectedCategoryId);
    },
    toggleLanguage() {
      const newLocale = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLocale
    },
    toggleMusic() {
      if (!this.musicUrl) {
        this.$message.warning(this.$t('message.musicLoading'))
        return
      }
      if (this.isMusicPlaying) {
        this.$refs.bgMusic.pause()
      } else {
        // 尝试播放音乐
        const playPromise = this.$refs.bgMusic.play()
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('播放失败，需要用户交互:', error)
          })
        }
      }
      this.isMusicPlaying = !this.isMusicPlaying
    },
    playMusic() {
      if (!this.musicUrl) return; // 如果没有音乐URL，则不播放
      // 移除自动播放
      this.isMusicPlaying = false
    },
    handleShare() {
      let url = window.location.origin + window.location.pathname
      if (this.selectedCategoryId && this.selectedPattern && this.selectedPattern.id) {
        url += `?cateId=${this.selectedCategoryId}&patternId=${this.selectedPattern.id}`
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success(this.$t('message.copySuccess'))
          if (this.$info) {
            this.$info({
              title: this.$t('message.button.share'),
              content: url,
              okText: this.$t('message.button.back')
            })
          }
        }).catch(() => {
          this.fallbackCopyTextToClipboard(url)
        })
      } else {
        this.fallbackCopyTextToClipboard(url)
      }
    },
    fallbackCopyTextToClipboard(text) {
      // 创建临时 input 元素
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success(this.$t('message.copySuccess'))
        if (this.$info) {
          this.$info({
            title: this.$t('message.button.share'),
            content: text,
            okText: this.$t('message.button.back')
          })
        }
      } catch (err) {
        this.$message.error(this.$t('message.copyFailed') || '复制失败，请手动复制链接')
      }
      document.body.removeChild(input)
    },
    selectPattern(pattern) {
      this.imageLoading = true
      this.selectedPattern = pattern
      // 确保显示有水图
      this.viewMode = 'full'
    },
    togglePatternPanel() {
      this.showPatternPanel = !this.showPatternPanel
    },
    patternName(item) {
      return this.$i18n.locale === 'zh' ? (item.china_name || '') : (item.english_name || '')
    },
    patternImageUrl(item) {
      if (!item || !item.image) return ''
      let url = item.image
      if (url.startsWith('/')) {
        return 'https://poollineradmin.landy360.com' + url
      }
      return url
    },
    categoryName(categoryItem) {
      if (!categoryItem) return ''
      return this.$i18n.locale === 'zh' ? categoryItem.name : categoryItem.english
    },
    categoryImageUrl(category) {
      if (!category || !category.image) return ''; 
      let imageUrl = category.image;
      if (imageUrl.startsWith('/')) { 
        if (!imageUrl.startsWith('http://') && !imageUrl.startsWith('https://')) {
          return 'https://poollineradmin.landy360.com' + imageUrl;
        }
      }
      return imageUrl;
    },
    handleImageLoad() {
      console.log('图片加载成功')
      this.imageLoading = false
    },
    handleImageError(e) {
      console.error('图片加载失败:', e)
      this.imageLoading = false
    },
    navigateToCategoryView() {
      this.panelView = 'categories';
    },
    async preloadImages() {
      const images = [];
      
      // 收集所有需要预加载的图片URL
      if (this.selectedPattern) {
        if (this.selectedPattern.have_image) images.push(this.selectedPattern.have_image);
        if (this.selectedPattern.not_image) images.push(this.selectedPattern.not_image);
        if (this.selectedPattern.detail_image) images.push(this.selectedPattern.detail_image);
      }
      
      // 收集分类图片
      this.categories.forEach(category => {
        if (category.image) images.push(category.image);
      });
      
      // 收集花色图片
      this.patterns.forEach(pattern => {
        if (pattern.image) images.push(pattern.image);
      });
      
      this.imagesToLoad = images;
      this.loadedImagesCount = 0;
      
      // 预加载所有图片
      const loadPromises = images.map(url => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            this.loadedImagesCount++;
            this.loadingPercent = 60 + Math.floor((this.loadedImagesCount / this.imagesToLoad.length) * 40);
            resolve();
          };
          img.onerror = () => {
            this.loadedImagesCount++;
            this.loadingPercent = 60 + Math.floor((this.loadedImagesCount / this.imagesToLoad.length) * 40);
            resolve(); // 即使加载失败也继续
          };
          img.src = this.processImageUrl(url);
        });
      });
      
      await Promise.all(loadPromises);
      this.loadingPercent = 100;
      
      // 延迟关闭加载页面，确保动画流畅
      setTimeout(() => {
        this.showLoading = false;
      }, 400);
    },
    processImageUrl(url) {
      if (!url) return '';
      try {
        url = decodeURIComponent(url);
        url = url.replace(/\\/g, '');
        if (!url.startsWith('https')) {
          url = 'https://poollineradmin.landy360.com' + url;
        }
        return url;
      } catch (e) {
        console.error('处理图片URL失败:', url, e);
        return url;
      }
    },
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      // 当滚动到距离底部20px时触发加载
      if (scrollHeight - scrollTop - clientHeight < 20) {
        if (this.hasMore && !this.isLoadingMore) {
          this.currentPage++;
          this.fetchPatterns(this.selectedCategoryId, true);
        }
      }
    },
    loadMore() {
      if (this.hasMore && !this.isLoadingMore && !this.patternsLoading) {
        console.log('开始加载新数据');
        this.currentPage++;
        this.fetchPatterns(this.selectedCategoryId, true);
      }
    }
  },
  watch: {
    viewMode: {
      handler(newMode) {
        this.imageLoading = true
        // 预加载新场景的图片
        const img = new Image()
        img.src = this.currentView
        img.onload = () => {
          this.handleImageLoad()
        }
        img.onerror = () => {
          this.handleImageError()
        }
      }
    }
  }
}
</script>

<style scoped>
.pc-home {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
}
.pool-view {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
}
.image-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: transparent;
}
.pool-image {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}
.control-panel {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 15px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.control-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.control-btn {
  width: 60px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 0;
  border-radius: 12px;
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  justify-content: center;
}
.control-btn:hover {
  background: rgba(255, 255, 255, 0.75);
  transform: translateY(-2px);
}
.control-btn .btn-icon {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  gap: 4px;
}
.control-btn .btn-icon .anticon {
  font-size: 24px;
  color: #333;
}
.control-btn .btn-icon img {
  width: 24px;
  height: 24px;
}
.control-btn .btn-text {
  font-size: 12px;
  color: #333;
  text-align: center;
  line-height: 1.2;
  width: 100%;
  display: block;
}
.control-btn.active {
  background: rgba(24, 144, 255, 0.3);
  border-color: rgba(24, 144, 255, 0.5);
}
.pattern-panel {
  position: fixed;
  left: -300px;
  top: 0;
  width: 300px;
  height: 100vh;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: left 0.3s;
  z-index: 1000;
  padding: 20px;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
}
.panel-logo {
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
}
.panel-logo img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
}
.panel-content-area {
  flex: 1;
  width: 100%;
  height: calc(100% - 100px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.pattern-panel-show {
  left: 0;
}
.panel-toggle-btn {
  position: fixed;
  z-index: 2000;
  width: 40px;
  height: 40px;
  background: rgba(24, 144, 255, 0.8);
  color: #fff;
  border-radius: 0 20px 20px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  transition: all 0.3s;
  cursor: pointer;
  top: 70px;
}
.panel-toggle-btn:hover {
  background: rgba(24, 144, 255, 1);
  box-shadow: 2px 0 12px rgba(24, 144, 255, 0.3);
}
.category-view, .pattern-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-x: hidden;
}
.ant-btn > .anticon + span, .ant-btn > span + .anticon {
  margin-left: 0 !important;
}
.category-view h3 {
  margin-bottom: 15px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #333;
}
.category-list {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
  overflow-x: hidden;
  display: grid !important;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.pattern-view .manual-pattern-grid {
  width: 100%;
  flex-grow: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  box-sizing: border-box;
  overflow-x: hidden;
  padding-bottom: 20px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}
.pattern-view .manual-pattern-grid::-webkit-scrollbar {
  width: 6px;
}
.pattern-view .manual-pattern-grid::-webkit-scrollbar-track {
  background: transparent;
}
.pattern-view .manual-pattern-grid::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}
.pattern-view .manual-pattern-grid::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
.pattern-view-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  flex-shrink: 0;
  box-sizing: border-box;
}
.pattern-view-header .back-button {
  margin-right: 10px;
}
.pattern-view-title {
  margin: 0;
  font-size: 1.1em;
  font-weight: 500;
  flex-grow: 1;
  text-align: center;
  color: #333;
}
.pattern-view .pagination {
  margin-top: 10px;
  padding-top: 0;
  flex-shrink: 0;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
}
.view-mode-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.view-mode-btn {
  width: 60px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 0;
  border-radius: 12px;
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}
.view-mode-btn:hover {
  background: rgba(255, 255, 255, 0.75);
  transform: translateY(-2px);
}
.view-mode-btn.active {
  background: rgba(24, 144, 255, 0.3);
  border-color: rgba(24, 144, 255, 0.5);
}
.view-mode-btn .btn-icon {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  gap: 4px;
}
.view-mode-btn .btn-icon .anticon {
  font-size: 24px;
  color: #333;
}
.view-mode-btn .btn-icon img {
  width: 24px;
  height: 24px;
}
.view-mode-btn .btn-text {
  font-size: 12px;
  color: #333;
  text-align: center;
  line-height: 1.2;
  width: 100%;
  display: block;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.ant-spin {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.ant-spin-container {
  width: 100vw;
  height: 100vh;
  position: relative;
}
.ant-spin-nested-loading {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
  overflow-x: hidden;
}
.ant-spin-blur {
  height: 100vh;
}
.ant-spin-blur::after {
  height: 100vh;
}
.pattern-name {
  text-align: center;
  margin-top: 8px;
  font-weight: bold;
  font-size: 16px;
}

/* Styles for Category List */
.category-item {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.category-item:hover {
  border-color: rgba(24, 144, 255, 0.5);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.category-item.selected-category {
  border-color: rgba(24, 144, 255, 0.5);
  background: rgba(24, 144, 255, 0.2);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.category-item-image {
  width: 100%;
  max-width: 150px;
  height: 80px;
  object-fit: cover;
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: #f0f0f0;
}
.category-item-no-image {
  width: 100%;
  max-width: 150px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: #f0f0f0;
  color: #999;
  font-size: 12px;
}

.category-item-name {
  font-size: 14px;
  text-align: center;
  color: #333;
  font-weight: 500;
}

/* Styles for Manual Pattern Grid */
.manual-pattern-item {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.manual-pattern-item:hover {
  border-color: rgba(24, 144, 255, 0.5);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.manual-pattern-item.selected-pattern-item {
  border-color: rgba(24, 144, 255, 0.5);
  background: rgba(24, 144, 255, 0.2);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.manual-pattern-item-image {
  width: 100%;
  max-width: 120px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 8px;
  background-color: #f0f0f0;
}

.manual-pattern-item-name {
  font-size: 12px;
  text-align: center;
  color: #333;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-patterns-message {
  grid-column: span 2;
  text-align: center;
  padding: 20px;
  color: #333;
}

.choose-pattern-tip {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.2) 100%);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.choose-pattern-tip .tip-text {
  margin-top: 16px;
  font-size: 20px;
  color: #333;
  font-weight: 500;
  letter-spacing: 2px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.loading-page {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-logo {
  width: 500px;
  max-width: 80vw;
  margin-bottom: 60px;
}
.loading-progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.loading-progress-text {
  margin-bottom: 10px;
  font-size: 16px;
  color: #1F3A74;
  font-weight: 500;
  text-align: center;
}
.loading-progress-bar {
  width: 120px;
  height: 28px;
  border: 3px solid #1F3A74;
  border-radius: 18px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.loading-progress-inner {
  height: 100%;
  background: #1F3A74;
  border-radius: 18px;
  transition: width 0.3s;
}
.loading-more {
  grid-column: span 2;
  text-align: center;
  padding: 10px 0;
  color: #333;
}
.loading-slogan {
  margin-top: 20px;
  text-align: center;
}

.slogan-cn {
  font-size: 18px;
  color: #333;
  font-weight: 500;
  margin-bottom: 8px;
}

.slogan-en {
  font-size: 16px;
  color: #666;
  font-weight: 400;
}

@keyframes music-wave {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.control-btn .anticon.music-playing {
  animation: music-wave 1.2s ease-in-out infinite;
}

.load-more-container {
  grid-column: span 2;
  padding: 20px 0;
  text-align: center;
  width: 100%;
}

.load-more-btn {
  min-width: 120px;
  height: 36px;
  border-radius: 18px;
  font-size: 14px;
  background: rgba(24, 144, 255, 0.8);
  border: none;
  transition: all 0.3s;
}

.load-more-btn:hover {
  background: rgba(24, 144, 255, 1);
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

/* Logo 样式 */
.pc-logo {
  position: fixed;
  top: 30px;
  left: 20px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 8px;
  padding: 6px;
  width: 260px;
  height: 120px;
}

.pc-logo img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
